import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as CloseIcon } from '@pkg/assets/icons/v2/close.svg';
import { ReactComponent as SearchIcon } from '@pkg/assets/icons/v2/search.svg';
import { useGetGlobalSearchResults } from '@pkg/components/GlobalSearch/hooks/useGetGlobalSearchResults';
import { InputText, type InputTextChange } from '@pkg/primitives';

import { GeneralSearchResult } from '../SearchResult';

import { CloseWrapper, IconWrapper, SearchResultWrapperMobile, StyledSearchInputMobile } from './styles';

export function SearchInputMobile() {
    const [translate] = useTranslation(['global_search']);

    const [value, setValue] = useState('');
    const { data, isLoading } = useGetGlobalSearchResults(value);

    const visibleClearButton = Boolean(value);

    const handleChange: InputTextChange = ({ target }) => setValue(target.value);

    function handleClearInput() {
        setValue('');
    }

    return (
        <>
            <StyledSearchInputMobile>
                <IconWrapper>
                    <SearchIcon />
                </IconWrapper>

                <InputText
                    type="search"
                    value={value}
                    placeholder={translate('search_placeholder_mobile')}
                    onChange={handleChange}
                    autoFocus={true}
                />

                {visibleClearButton && (
                    <CloseWrapper $visible onClick={handleClearInput}>
                        <CloseIcon />
                    </CloseWrapper>
                )}
            </StyledSearchInputMobile>

            <SearchResultWrapperMobile>
                <GeneralSearchResult results={data} query={value} loading={isLoading} />
            </SearchResultWrapperMobile>
        </>
    );
}
